import { preloadContentAnalyticsViewers } from '@confluence/confluence-analytics/entry-points/preloadContentAnalyticsViewers.ts';
import {
	slowQueryGuard,
	SLOW_QUERY_DEFAULT_TIMEOUT,
} from '@confluence/query-preloader-tools/entry-points/slowQueryGuard.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { preloadReadTime } from '@confluence/read-time/entry-points/preloadReadTime.ts';

import ContentTitleExternalQuery from './content-title/__generated__/ContentTitleExternalQuery.graphql.ts';
import type {
	ContentTitleExternalQuery$data,
	ContentTitleExternalQuery as ContentTitleExternalQueryType,
	ContentTitleExternalQuery$variables as ContentTitleExternalQueryVariables,
} from './content-title/__generated__/ContentTitleExternalQuery.graphql.ts';

import ExternalByLineQuery from './by-line/__generated__/ExternalByLineQuery.graphql.ts';
import type {
	ExternalByLineQuery$data,
	ExternalByLineQuery as ExternalByLineQueryType,
	ExternalByLineQuery$variables as ExternalByLineQueryVariables,
} from './by-line/__generated__/ExternalByLineQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

type PreloadReadTimeResult = Awaited<ReturnType<typeof preloadReadTime>>;

export function preloadContentTitleWithByLineExternal(contentId: string): Promise<
	| void
	| Error[]
	| (
			| boolean
			| PreloadReadTimeResult
			| {
					data: ContentTitleExternalQuery$data | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
			| {
					data: ExternalByLineQuery$data | null;
					errors?: ReadonlyArray<GraphQLError>;
					hasErrors: boolean;
			  }
	  )[]
> {
	return waitForAllReturnWhenError([
		query<ContentTitleExternalQueryType['response'], ContentTitleExternalQueryVariables>({
			query: ContentTitleExternalQuery,
			variables: { contentId },
			context: {
				allowOnExternalPage: true,
			},
		}),
		query<ExternalByLineQueryType['response'], ExternalByLineQueryVariables>({
			query: ExternalByLineQuery,
			variables: { contentId },
			context: {
				allowOnExternalPage: true,
			},
		}),
		preloadReadTime({ contentId, includeContentBody: true, useCache: true }),
		slowQueryGuard(
			'preloadContentAnalyticsViewers',
			() => preloadContentAnalyticsViewers(contentId),
			SLOW_QUERY_DEFAULT_TIMEOUT,
		),
	]);
}
